<template>
  <div>
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-dark">
        <!-- Insert Image Here -->
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto"></div>
          <div class="col-lg-6 order-lg-1">
            <div class="pl-0">
              <h4 class="display-3 text-white">Church Planting</h4>
              <p class="text-white">
                Learn about our church planting initiatives and how you can be part of
                these exciting missions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 1. OBCM San Ildefonso, Bulacan (1984) -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM San Ildefonso, Bulacan</h2>
            <h5>Year Planted: 1984</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              About 65 kms. North of Manila, our worship service evolved from a living
              room to a garage, then to Borja Subdivision. This was conceived while I was
              assigned to the Bataan Refinery (Limay, 1981) Corp., an affiliate of Petron
              Corp. I started a Bible study at Maasim, San Ildefonso, Bulacan, hosted by
              Cipriano Violago and Remy Violago. While sharing a testimony with the Olivet
              Baptist Church (OBCM Sta. Ana) on Sunday morning, Sis. Lina Mata Eisma,
              learning of the location, made an invitation to start a Bible study in the
              Mata Family Compound at Lapnit, San Ildefonso, to which I agreed, “A
              testimony about God is a powerful tool to share the gospel to the
              unreached.” God allowed a simple invitation to establish what is now OBCM
              San Ildefonso and its daughter church, OBCM Gabihan, pastored by Rodnie
              Mata. OBCM San Ildefonso was led by a homegrown Pastor Reynaldo Mata for
              more than three decades and was succeeded by Pastor Eduardo Constantino
              after Pastor Rey retired. Pastor Ignacio Eisma also had been a part and
              instrument to its growth as a church over the years.
            </p>
            
            <img
              v-lazy="'img/church-planting/obcm-bulacan.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM San Ildefonso, Bulacan (1984)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 2. OBCM Rosario, Cavite (1988) -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Rosario, Cavite</h2>
            <h5>Year Planted: 1988</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              I was transferred from Bataan to Cavite, 30 km south of Manila, to manage a
              66-hectare oil and gas facility. I stayed in this new assignment from 1988
              to 1991. God opened an opportunity for me to lay the groundwork for OBCM
              Rosario, Cavite. God sent to me Pastor Alex Dulay, now based in San Diego,
              USA, to assist me in starting Bible studies. I first started Bible studies
              and ministry among my company security personnel (40 men) and my staff (14
              men). We resided in the company’s housing facilities, allowing access to the
              stay-in guards at the barracks. We later on rented a place outside the
              company’s premises in a more neutral location for prospective visitors to
              join the worship gatherings. Pastor Alex stayed there to conduct Bible
              studies, visitations, and other ministries necessary wherever opportunity
              arose. We prayed and planned to purchase a lot and construct the church
              within the town of Rosario, Cavite. God granted us a 400 sqm lot at Tramo,
              Rosario, Cavite, where the OBCM Rosario is presently situated. Ministering
              in order to plant a new church is a real challenge considering that we need
              to address the financial, manpower, and time aspects and the kind of
              methodology we are to adopt to come up with the outcome we envisioned.
              Again, God is our constant companion, provider, healer, and strength. God
              sent laborers for the harvest as we knelt down in prayer. He used ordinary,
              less educated, weak vessels so that His power may manifest in weakness.
              Pastors from the mother church joined, as did other daughter churches in the
              cooperative mission to ensure that the ministry work is sustained. In 1988,
              Pastor Charlito Escultor came up as an unlikely man chosen by God. Unlikely
              for the simple reason that he was charged first to take care of the church
              facilities (lot & building). Without any formal seminary training or college
              degree but possessing an unwavering faith and commitment to face every
              challenge in front of him, he was called to pastor OBCM Rosario. I
              personally witnessed the testing after testing of faith he went through. Now
              a graduate of PBTS with an associate in ministerial training, he proved
              himself faithful to his call. Now, more than 3 decades of pastoral
              leadership in OBCM Rosario Cavite, his unquestionable faith, and commitment
              to the ministry of the Gospel are evidenced by God’s power, love, and
              sustenance for the kind of man He chooses.
            </p>

            <img
              v-lazy="'img/church-planting/obcm-rosario.jpeg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Rosario, Cavite (1988)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 3. OBCM Fairview, Quezon City (2003) -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Fairview, Quezon City</h2>
            <h5>Year Planted: 2003</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              Two thousand three (2003) was the year we started doing Bible studies with a
              very enthusiastic follower of Christ. A company that Brother Willie Angeles
              invited us to conduct Bible studies among his employees. Having a flair in
              the construction business, he proposed developmental projects for OBCM Sta.
              Ana and other satellite churches, especially those with meager budgets. We
              collaborated and started the Christian Builder Ministry, a construction
              ministry arm of OBCM Sta. Ana. From the workers, the Bible study extended to
              the houses of employees, and one of them is now Pastor Jose Matriz, living
              in Fairview, Quezon City. That Bible study grew and eventually evolved as an
              OBCM house church. Pastor Joe became their lay leader & eventually the
              senior pastor. People in their community heard and experienced the Gospel
              proclamation and followed the Lord through water baptism and remaining
              faithful in the ministry of Jesus Christ.
            </p>

            <img
              v-lazy="'img/church-planting/obcm-fairview.jpeg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Fairview, Quezon City (2003)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 4. OBCM Imus, Cavite (2003) -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Imus, Cavite</h2>
            <h5>Year Planted: 2003</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              Pastor Ricardo Roman is the founding pastor of OBCM Imus. When he assumed
              the pastorate in OBCM Rosario during its formative years, he caught a vision
              of starting a church where his family resides. God usually urges
              missionaries to go forward to another town and share the Good News of
              salvation. It was when Pastor Charlito Escultor was ready to assume
              responsibility in OBCM Rosario that Pastor Ric made the decision to
              spearhead a ministry in Imus. Competency and the all-out support of the
              cooperative network of Great Commission Churches (OBCM Assn.) and family
              support, as well as a resolve and committed spirit to obey God, enabled us
              to plant the church in Imus. OBCM Sta. Ana played a crucial role in the
              realization of this vision. They stayed strong to this day under Pastor Ric
              Roman’s leadership, assisted by Pastor Marcos Barbas and Pastor Ric’s son,
              fondly known as Eboy.
            </p>

            <img
              v-lazy="'img/church-planting/obcm-imus.jpeg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Imus, Cavite (2003)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 5. OBCM Morong, Bataan (2005) -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Morong, Bataan</h2>
            <h5>Year Planted: 2005</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              When I retired in 1991 (early retirement), our family bought a 1.5-hectare
              farm lot in Morong. It was at that time when God showed me an opportunity to
              start praying to plant a church among the relocated families from the
              Philippine Refugee Processing Center. Around 50 families were initially
              given a place (100 sqm) to build their houses. It was a timely opportunity
              to approach/welcome them in their new community and to their new location
              that was provided for them. It was an entry point for sharing the Gospel
              with a view of planting an indigenous church. We conducted medical/dental
              missions and food and medicine distributions and held Vacation Bible
              Schools. We eventually established a church-based preschool for children. It
              was in operation for 4 years, after which a new church emerged, which is now
              known as OBCM Morong, Bataan. To this day, OBCM Morong is one of the closest
              local churches for our family, as we decided to reside permanently in
              Morong. Pastor Adorable Laxa assumed leadership from the late Pastor Jerry
              Abendan and Pastor Joselito Reyes. God manifested His overflowing grace and
              mercy to the community of Brgy. San Isidro, Sabang, Morong, Bataan, because
              of the many student scholars assisted by OBCM Sta. Ana, who prayed for
              acquiring education degrees and are now professional teachers such as Sis.
              Renna Domingo, Sis. Lorie Jim Feliciano and many others who submitted their
              lives to Jesus Christ. God deserves all the glory!
            </p>

            <img
              v-lazy="'img/church-planting/obcm-bataan.jpeg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Morong, Bataan (2005)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 6. OBCM Baco, Oriental Mindoro (2007) -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Baco, Oriental Mindoro</h2>
            <h5>Year Planted: 2007</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              I served a term with the Luzon Convention of Southern Baptist in the early
              90’s as the Chairman of the Committee on Mission and Evangelism, working
              along with Pastor Arman dela Merced as Home Missions Director, Dr. Armand
              Canoy, our Executive Director, and President Ding Guevarra. It was at that
              point that I had the opportunity to travel to the island province of
              Oriental Mindoro, where communities of indigenous people (the Alangan
              Mangyans) were settled at the foot of Mt. Halcon. In response to a letter
              seeking help, we explored the area, together with two senior pastors, Pastor
              Ignacio Poja (OBCM Sta. Ana) and Pastor Fabiala of Bansud, Oriental Mindoro,
              to meet the Alangan Tribe. Along the mountain trails we met a strange local
              Mangyan guide coincidentally named Simon Peter, and he led us to experience
              God’s powerful provision and guidance going to our destination. Challenged
              to plant a new indigenous church to minister to tribal people of Mindoro, we
              asked them to pray so that we could purchase a property that would fit the
              ministry among the tribes. Much to our amazement, a week later, God granted
              our prayers to start this mission among the tribal people by providing us
              with a sprawling 4-hectare orchard to construct a church. Now on its 18th
              anniversary, the church is led by Pastor Cornelio Jonson, as development
              work is ongoing but ready to minister for the Gospel.
            </p>

            <img
              v-lazy="'img/church-planting/obcm-baco.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Baco, Oriental Mindoro (2007)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 7. OBCM Mexico, Pampanga (2007) -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Mexico, Pampanga</h2>
            <h5>Year Planted: 2007</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>

            <p class="lead">
              I believe this church in Central Luzon, 70 kms north of Manila, is the
              product of the power of prayer of Brother Eden Rivera and his wife, Mona,
              who are residing in Lakewood, California, to share the Gospel with their
              family and relatives residing in the Philippines. Whenever we visit
              California, this family sees to it that we stay and lodge in their welcoming
              home. We would enjoy their fellowship, studying the Bible, worship service,
              family prayer, visitation, and counseling, not to mention the trips, and
              going to various places (as a tourist) is always a pleasure. In one of our
              visits to California, God, who instilled in us to do and act in accordance
              with His love and mercy, convicted us to visit the Rivera Family in
              Pampanga, people needing God’s salvation through Jesus Christ. Brother Eden
              requested us to meet his parents in Mexico, Pampanga, and bring a cane and a
              hat for his father, who was then in his 80s, and his mother, with
              instructions for me to lead a Bible study for the very first time in their
              home. We were then met at the NLEX exit toll gate at Mexico, Pampanga, to
              head to their house in Barangay Culubasa. With me is my wife, Epie, and
              Sister Menchie Talosig, the younger sister of Sister Mona. To summarize the
              long story, after our first Bible study, Nanay Ella, Eden’s mom, invited us
              to come back the following Sunday for their Catholic celebration of Town
              Fiesta in honor of their patron saints and partake of specially cooked
              Pampanga sumptuous delicacies. God’s wisdom opened for us an opportunity to
              reply courteously to the sincere invitation to share the Gospel of Jesus
              Christ. I said , “Thank you for your invitation, Nanay, but going back here
              from Manila to enjoy the food and celebrate is costly and a real challenge
              for us to do because of the distance and remoteness of your location, but if
              your invitation is about having a Bible study, we will have no reason not to
              come". Her immediate reply was, “Let’s have Bible study then.” God paved the
              way for them to hear the message of salvation—the family, relatives, and
              friends of the Riveras. Fast forward, their youngest brother, now Pastor
              Marlon Rivera, and his family later on committed their lives to the Lord.
              Pastor Marlon heard God's calling, and his household is happily serving
              their local church, and a lot and building helped purchased by OBCM Sta. Ana
              with construction initiated by the OBCM Christian Builders. The Rivera
              family and Brother Eden committed their faith to supporting the Lord’s
              ministry in Mexico, Pampanga. “I planted the seeds, Apollos watered, but God
              gave the increase.” - 1 Corinthians 3:6-8. All glory to God alone!
            </p>

            <img
              v-lazy="'img/church-planting/obcm-mexico.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Mexico, Pampanga (2007)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 8. OBCM Mamburao, Occidental Mindoro (2008) -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Mamburao, Occidental Mindoro</h2>
            <h5>Year Planted: 2008</h5>
            <p><i>Written in the perspective of Ptr. Joel Idurot</i></p>
            
            <p class="lead">
              Mamburao is the capital of Occidental Mindoro, located on the eastern part
              of the island. The Christian ministry was initiated by the women's
              fellowship of California-based Grace Redemption Church (SB) in the early
              2000s but with no property or building to house the church. So it started in
              a motor pool owned by Sister Gina Bonifacio and employed a young worker to
              minister to the people around the town by extending help to people in need
              and sharing the Gospel. An officer of the Filipino Southern Baptist Ministry
              based in California—Ptr. Eduardo Peol contacted us through LCSBC to assist
              in planting a healthy reproducing church advocated by the Church
              Multiplication Movement by way of sending pulpit ministers to do visitation
              and Sunday preaching until it was tested with various issues and leadership
              problems in the church. The place of worship was relocated to the town
              proper for strategic reasons, and then God called then Bro. Novelino
              Facalarin, the supposed owner of the new venue for the gathering. He was
              observed to be a devoted follower of Jesus after his conversion and was
              generous in many ways and most of all loved the Lord, the Church, and the
              ministry. He was later on called and ordained as pastor. By the way, we
              fondly call him by his nickname PNP (Pastor na Pilay) since he was a stroke
              survivor. Still recovering, having difficulty in his every stride when he
              walks. The birth of the church in Mamburao had its turning point when a
              property in the most unlikely location was offered via donation by Pastor
              Novie at Sitio Aroma, a densely populated area of fisherfolk. At that time
              the place sometimes appears and disappears depending on the tide’s ebb and
              flow. This was a critical time in the ministry because Grace Redemption
              Church of California refused to approve the location. In response, we wrote
              a formal letter to GRC that OBCM is withdrawing from its commitment to send
              ministers to Mamburao because of the above reason. However, the standing
              church members decided to pursue the church ministry and still wanted to be
              part of OBCM. They then wrote a formal letter to GRC of their decision for
              the same reason and formally became OBCM Mamburao, a thriving church led by
              Pastor Novie until his demise. It is presently assisted through the
              Cooperative Missions from the OBCM Association. I think contrary to the
              common belief that God is on a mission and we are participants. We could
              have named this local church Underwater Baptist Church, based on our
              experiences of arriving at Sunday morning service at 8:00 AM and leaving
              after the worship service, now with knee-high seawater on the street. OBCM
              Mamburao church is thriving and growing in the LORD. Hallelujah!
            </p>

            <img
              v-lazy="'img/church-planting/obcm-mamburao.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Mamburao, Occidental Mindoro (2008)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 9. Pagsanjan, Laguna - Outreach (2023) -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Pagsanjan, Laguna - Outreach</h2>
            <h5>Year Started: 2023</h5>
            <p class="lead">
              God has opened a wonderful door for OBCM Sta. Ana to partner in the work of
              the gospel in Pagsanjan, Laguna. Since April 2023, under the leadership of
              Ptr. Uziel Idurot, the church has joined hands with Bro. Romeo and Sis.
              Madilene Villarino, a faithful couple who started this outreach years ago.
              With hearts burdened for their community, Bro. Romeo and Sis. Madilene have
              been gathering children from their neighborhood to teach them about the love
              and salvation of Jesus Christ. What began as a simple effort to share Bible
              stories has grown into a thriving ministry that continues to touch young
              lives. Through this partnership, volunteers from OBCM Sta. Ana and RCF
              Marikina regularly travel to Pagsanjan to assist in Bible teaching and
              discipleship. Together, they bring songs, stories, and the message of hope
              in Christ to the next generation.We praise God for the seeds of faith being
              Started and pray that many more children and families in Pagsanjan will come
              to know and follow Jesus Christ
            </p>

            <img
              v-lazy="'img/church-planting/obcm-pagsanjan.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Pagsanjan, Laguna (2023)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 10. OBCM Gabihan, San Ildefonso, Bulacan (2024) -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Gabihan, San Ildefonso, Bulacan</h2>
            <h5>Year Planted: 2024</h5>
            <p class="lead">
              The journey of this planted church began humbly and wholeheartedly with the
              Children’s Ministry launched in 2012. What started as a small outreach for
              local children became the fertile soil from which a vibrant faith community
              would flourish. Dedicated volunteers and ministry leaders from OBCM Bulacan,
              poured into young hearts, laying spiritual foundations through Bible
              stories, songs, and moments of prayer. By 2024, the vision expanded into
              formal church gatherings, marking a new season of growth and fellowship. The
              gatherings brought together attendees, including the children’s relatives,
              baptized believers, and fostering a shared worship and discipleship. The
              church’s activities now include: (1) Children’s Ministry – A cornerstone
              outreach that continues to inspire and engage young minds. (2) Sunday School
              – A nurturing space for biblical learning across age groups. (3) Prayer
              Meetings – Weekly gatherings where the community seeks spiritual guidance
              and intercedes together. (4) Worship Services – Joyful expressions of praise
              that unite all in faith and purpose. With God’s grace and the community’s
              commitment, the church continues to grow—not just in numbers, but in impact.
              It stands as a testimony to faith cultivated patiently and joyfully, one
              child, one family, and one prayer at a time
            </p>

            <img
              v-lazy="'img/church-planting/obcm-gabihan.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Gabihan, San Ildefonso, Bulacan (2024)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 11. OBCM San Pedro, Laguna (2024) -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM San Pedro, Laguna</h2>
            <h5>Year Planted: 2024</h5>
            <p class="lead">
              A church located in an unlikely place, within the marketplace of San Pedro,
              Laguna. It was realized and conceived through prayers and efforts of Pastor
              Arvick Mirondo and the leadership of OBCM Sta. Ana. Now on its 1st year of
              gathering as a church, it has sustained the ministry for people around San
              Pedro. The church leaders have also complemented the needs of the OBCM
              Association for venues for yearly Family Sports Fest, and host to the 50th
              Anniversary of OBCM Sta. Ana. As they continue to grow in number and
              spiritual maturity, the church continues to contemplate acquiring their own
              and more permanent place of worship, while its affiliation with the OBCM
              Association Cooperative mission obviously would determine this future
              endeavour. God honors the desires and prayers of the faithful.
            </p>

            <img
              v-lazy="'img/church-planting/obcm-san-pedro.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM San Pedro, Laguna (2024)"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 12. Crossing Bataan, Morong - Outreach (2024) -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Crossing Bataan, Morong - Outreach</h2>
            <h5>Year Started: 2024</h5>
            <p class="lead">
              In the midst of the development going on at the coastal village of Crossing,
              Panibatuhan, Morong, Bataan, a 700 sqm property and a newly built Church
              edifice is almost ready to be launched with a team ready to invite local
              fisherfolks and families near it to hear the Gospel. OBCM Sta. Ana is at the
              forefront planting this new Church in collaboration with the OBCM
              Association. The Christian Builders Ministry, participated by Church leaders
              and members continues to help finish the church building, with Brother
              Alphonse Rodriguez as the point person in charge of the construction of the
              building with some amenities like washrooms and shower rooms. Our
              cooperative mission working critically will determine the outcome and
              pursuit of God’s work in this area. Our prayer is for God to open the way to
              the hearts of the people who hear the message of salvation in Jesus Christ
              in that place.
            </p>

            <img
              v-lazy="'img/church-planting/obcm-crossing.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Crossing Bataan, Morong (2024)"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "church-planting",
  components: {},
};
</script>

<style scoped>
.gcash-number {
  font-weight: bold;
  font-size: 2.5rem;
  color: #212329;
}
</style>
